import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import store from './store';

import Router from './router';

Sentry.init({
    dsn: 'https://a1107d8a75aa8bb6e8a652277cefee34@o1132036.ingest.us.sentry.io/4507364620435456',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0,
});

ReactDOM.createRoot(
    document.getElementById('ustoreit-rapidstor-frontend') as HTMLElement
).render(
    <React.StrictMode>
        <Provider store={store}>
            <RouterProvider router={Router} />
        </Provider>
    </React.StrictMode>
);
